module.exports = __webpack_public_path__ + "static/Akshay_Chandrashekar-26df6bff626a8573caba9e567c8a0eaf.jpg";